<template>
    <!-- eslint-disable max-len -->
    <div id="topHeader">
        <img src="@/assets/bitmap.png">
        <h1>{{ title }}</h1>
    </div>
</template>

<script>
export default {
  name: 'topHeader',
  data() {
    return {
      title: this.$translation.L('KMMF_TITLE'),
    };
  },
};
</script>

<style scoped>

img {
  float: left;
  height: 4vw;
  margin-right: 3vw;
}

#topHeader {
  padding: 0;
  display: inline-block;
  margin-top: 0.2vh;
  margin-bottom: 0.5vw;
}

#topHeader h1 {
  font-size: 2.6vw;
  float: left;
}

@media only screen and (max-width: 1023px) {
  #topHeader h1 {
    font-size: 8vw;
  }

  img {
    display: inline-block;
    float: none;
    height: 12vw;
  }
}
</style>
